module.exports = __webpack_public_path__ + "static/img/ent-detail-35.16055c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-35.jpg
// module id = FKK3
// module chunks = 51